import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  freeBetStore,
  wageringStore,
  BetResponseCode,
  gameConfigStore,
  applicationStore,
  notificationStore,
} from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../enums';
import { doBetStore, gameStore } from '../../store';
import { plus } from '../../helpers/arithmeticOperations';
import { autoBetDataKeys, autoCashOutDataKeys } from '../../enums/uiConfig';

export const BetButton = observer(
  ({
    t,
    autoBetData,
    fighterData,
    isNotHaveActiveBets,
    decidedCallBackCall,
    currentFighterSection,
  }) => {
    const { amount, betId, isDisabled, isBetAccepted, isNextRoundBet, freeBetId, freeBetMinOdd } =
      fighterData;

    const {
      limits: { maxBet },
    } = gameConfigStore;

    const { isDemo } = applicationStore;
    const { totalBetsAmount } = doBetStore;
    const { activeFreeBet } = freeBetStore;
    const { partnerWageringOdd } = wageringStore;
    const { InValidMaxBet } = BetResponseCode;
    const { isBetsClosed, oddData, isRoundFin, time } = gameStore;
    const { isAutoBet, autoBetCount, isOpened } = autoBetData;
    const { Bet, CashOut, BetForNextRound, Cancel, FreeBet, Stop, MinOdd, Wait } =
      globalTranslationKeys;

    const betButtonContent = useMemo(() => {
      return betId && isBetAccepted && !isNotHaveActiveBets
        ? CashOut
        : oddData && !isNextRoundBet && (!isBetAccepted || isNotHaveActiveBets) && !isAutoBet
        ? BetForNextRound
        : isNextRoundBet && oddData && !isRoundFin
        ? Cancel
        : isAutoBet && autoBetCount && oddData && isNotHaveActiveBets && !isRoundFin
        ? Stop
        : (isNextRoundBet || isAutoBet) && isRoundFin
        ? Wait
        : activeFreeBet.id
        ? FreeBet
        : Bet;
    }, [
      betId,
      oddData,
      isAutoBet,
      isRoundFin,
      autoBetCount,
      activeFreeBet,
      isBetAccepted,
      isNextRoundBet,
      isNotHaveActiveBets,
    ]);

    const activeClassName = useMemo(() => {
      if (isAutoBet && (autoBetCount ?? 0)) {
        if (isBetAccepted) {
          return CashOut;
        }
        return Cancel;
      }
      return betButtonContent;
    }, [isAutoBet, autoBetCount, isBetsClosed, isBetAccepted, isOpened, isNextRoundBet]);

    const handleBetButtonEvents = useCallback(
      (index) => {
        if (!isBetAccepted && !oddData && !isBetsClosed) {
          doBetStore.doBetSender(index);
        } else if (isNotHaveActiveBets && isBetsClosed && oddData && !isAutoBet && !isRoundFin) {
          doBetStore.handleBetForNextRound(index);
        }
      },
      [isBetAccepted, isBetsClosed, oddData, isNotHaveActiveBets, isAutoBet, isRoundFin]
    );

    const currentActiveClass = useMemo(() => {
      if (((isAutoBet && autoBetCount && oddData) || (isNextRoundBet && oddData)) && !isRoundFin)
        return 'state-red';
      if (
        (!isAutoBet && !autoBetCount && !isDisabled && !betId && time) ||
        (oddData && (!betId || isNotHaveActiveBets) && !isRoundFin)
      )
        return 'state-green';
      return 'wait-state';
    }, [
      time,
      betId,
      oddData,
      isAutoBet,
      isDisabled,
      isRoundFin,
      autoBetCount,
      isNotHaveActiveBets,
    ]);

    return (
      <div
        className='bet-button-container'
        onClick={() => {
          if (
            isDemo &&
            plus(Number(amount), Number(totalBetsAmount)) > Number(maxBet) &&
            !isBetAccepted
          ) {
            notificationStore.setNotificationType({ responseCode: InValidMaxBet });
          } else {
            if (!doBetStore.autoCashOutData[currentFighterSection].isValidatedOdd) {
              decidedCallBackCall(() => {
                if (
                  isAutoBet &&
                  autoBetCount &&
                  (activeClassName !== CashOut || isNotHaveActiveBets)
                ) {
                  doBetStore.updateAutoBetData(
                    autoBetDataKeys.isAutoBet,
                    false,
                    currentFighterSection
                  );
                  doBetStore.updateAutoBetData(
                    autoBetDataKeys.autoBetCount,
                    null,
                    currentFighterSection
                  );
                  doBetStore.updateAutoBetData(
                    autoBetDataKeys.isOpened,
                    false,
                    currentFighterSection
                  );
                  doBetStore.updateIsDisabledBetSection(false, currentFighterSection);
                } else {
                  handleBetButtonEvents(currentFighterSection);
                }
              }, true);
            } else {
              doBetStore.updateAutoCashOutData(
                autoCashOutDataKeys.isValidatedOdd,
                false,
                currentFighterSection
              );
            }
          }
        }}
      >
        {/* ADD CLASS "STATE-GREEN WAIT-STATE, STATE-RED, TRY-AGAIN" */}
        <button
          className={`bet-button ${currentActiveClass} ${
            currentActiveClass === 'state-green' ? 'pulse-btn' : ''
          }`}
        >
          {!isDisabled && (
            <span
              className={`bet-btn-text ${
                betButtonContent === BetForNextRound ? 'bet-for-next' : ''
              }`}
            >
              {t(betButtonContent)}
            </span>
          )}
          {((freeBetId && !activeFreeBet.isMinOddNull) || partnerWageringOdd) && !isDisabled && (
            <span className='bet-btn-free-odd-text'>{`${t(MinOdd)} x${
              freeBetMinOdd || partnerWageringOdd
            }`}</span>
          )}
          {!oddData && isDisabled ? (
            <div className='loading-block'>
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          ) : (
            <></>
          )}
        </button>
      </div>
    );
  }
);
